module.exports = __webpack_public_path__ + "img/252.0f636a0c.jpg";